import { render, staticRenderFns } from "./CKycAddressDetails.vue?vue&type=template&id=c7ca01fc&scoped=true&"
import script from "./CKycAddressDetails.vue?vue&type=script&lang=js&"
export * from "./CKycAddressDetails.vue?vue&type=script&lang=js&"
import style0 from "./CKycAddressDetails.vue?vue&type=style&index=0&id=c7ca01fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ca01fc",
  null
  
)

export default component.exports